module.exports = __webpack_public_path__ + "img/price-click-1.297df741.webp";